// extracted by mini-css-extract-plugin
export var futureProofSection = "futureProof-module--futureProofSection--0Og+U";
export var futureProofVectorWrapper = "futureProof-module--futureProofVectorWrapper--28FaU";
export var futureProofRow = "futureProof-module--futureProofRow--Vped8";
export var futureProofCol = "futureProof-module--futureProofCol--C+Qt9";
export var futureProofTextWrapper = "futureProof-module--futureProofTextWrapper--xostJ";
export var futureProofImgWrapper = "futureProof-module--futureProofImgWrapper--Qs0Ph";